import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const BRANDING_ENDPOINT = 'branding/v1/branding';
export function getBrandingDetails() {
  return http.get(`${BRANDING_ENDPOINT}/${PortalIdParser.get()}/get-or-default?useHubsDomain=true`).catch(error => {
    throw new Error(error.message);
  });
}